import {
    multipleSelectionNumberPattern,
    multipleSelectionContact,
    multipleSelectionContacts,
    multipleSelectionContactList,
    multipleSelectionContactLists,
    multipleSelectionConjunction,
} from './locstringsUtils.locstring.json';
import { multipleSelectionSelected } from 'owa-locstrings/lib/strings/multipleselectionselected.locstring.json';
import loc, { format } from 'owa-localize';

import { HubPersonaType, PersonType } from '../models';

export function getCountStringForCurrentPersonas(
    currentPersonaTypes: HubPersonaType[],
    includeSelectedString?: boolean
): string {
    let contactsCount = 0;
    let clCount = 0;

    currentPersonaTypes.forEach(type => {
        switch (type) {
            case PersonType.Person:
            case PersonType.FavoritePerson:
                contactsCount++;
                break;
            case PersonType.PrivateDistributionList:
                clCount++;
                break;
            default:
                break;
        }
    });

    const contactsString = contactsCount
        ? format(
              loc(multipleSelectionNumberPattern),
              contactsCount,
              contactsCount === 1 ? loc(multipleSelectionContact) : loc(multipleSelectionContacts)
          )
        : null;

    const contactListsString = clCount
        ? format(
              loc(multipleSelectionNumberPattern),
              clCount,
              clCount === 1 ? loc(multipleSelectionContactList) : loc(multipleSelectionContactLists)
          )
        : null;

    let bothString = '';

    if (contactsString && contactListsString) {
        bothString = format(loc(multipleSelectionConjunction), contactsString, contactListsString);
    } else if (!contactsString) {
        bothString = contactListsString;
    } else {
        bothString = contactsString;
    }

    return includeSelectedString ? format(loc(multipleSelectionSelected), bothString) : bothString;
}
